import { authHeader } from '../helpers'
import { helper } from './serviceHelper'
const _package = require('../../package.json')
const store_name = `useryaa-${_package.version}`

export const userService = {
	login,
	loginToken,
	logout,
	register,
	validateToken,
	getYaaUserProfileById,
    sendMail,
    GetAcceptDisclamer,
    AcceptDisclamerLog,
}

function login(username, password) {
	const requestOptions = {
		method: 'POST',
		headers: { ...authHeader(), 'Content-Type': 'application/json' },
		body: JSON.stringify({ username, password }),
	}

	return fetch(`api/users/authenticate`, requestOptions)
		.then(handleResponse)
		.then(user => {
			// login successful if there's a jwt token in the response

			if (user.token) {
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				localStorage.setItem(`${store_name}`, JSON.stringify(user))
			}

			return user
		})
}

function GetAcceptDisclamer(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`api/users/GetAcceptDisclamer/${id}`, requestOptions).then(helper.handleResponse)
}

function AcceptDisclamerLog(id,acceptType) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: id, acceptType:acceptType  }),
    }

    return fetch(`api/users/AcceptDisclamerLog`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

function loginToken(token) {
	const requestOptions = {
		method: 'POST',
		headers: { ...authHeader(), 'Content-Type': 'application/json' },
		body: JSON.stringify({ token: token }),
	}

	return fetch(`api/users/authenticateToken`, requestOptions)
		.then(handleResponse)
		.then(user => {
			// login successful if there's a jwt token in the response
			if (user.token) {
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				localStorage.setItem(`${store_name}`, JSON.stringify(user))
			}

			return user
		})
}

function logout() {
	for (let i = 0; i < localStorage.length; i++) {
		if (localStorage.key(i).indexOf(`useryaa`) > -1) {
			console.log('...remove store', localStorage.key(i))
			localStorage.removeItem(localStorage.key(i))
		}
	}
}

function register(user) {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(user),
	}

	return fetch(`api/users/register`, requestOptions).then(handleResponse)
}

function validateToken(token) {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ token: token }),
	}

	return fetch(`api/users/validate`, requestOptions).then(handleResponse)
}

function handleResponse(response) {
	return response.text().then(text => {
		const data = text && JSON.parse(text)
		if (!response.ok) {
			if (response.status === 401) {
				// auto logout if 401 response returned from api
				logout()
				window.location.reload(true)
			}

			const error = (data && data.message) || response.statusText
			return Promise.reject(error)
		}

		return data
	})
}

function getYaaUserProfileById(id) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	}

	return fetch(`api/services/GetYaaUserProfileById/${id}`, requestOptions).then(helper.handleResponse)
}

function sendMail(data) {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
		body: JSON.stringify(data),
	}

	return fetch(`api/users/SendMailAg`, requestOptions).then(helper.handleResponse)
}
